import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-times",
  "use": "icon-times-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-times\">\r\n  <path d=\"M20,16.823,13.071,9.983l6.833-6.9L16.823,0,9.98,6.932,3.055.1,0,3.151l6.934,6.867L.1,16.945,3.151,20l6.864-6.932,6.9,6.836Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol